import { all } from '@redux-saga/core/effects';

import AuthSaga from '../saga/Auth.saga';
import UserSaga from '../saga/User.saga';

export default function* rootSaga() {
	yield all([UserSaga(), AuthSaga()]);
}
